import cmp from './MyOffers'

export default cmp
